import { render, staticRenderFns } from "./IdentificationForm.vue?vue&type=template&id=732d8074"
import script from "./IdentificationForm.vue?vue&type=script&lang=ts"
export * from "./IdentificationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports